import { extension } from 'mime-types';

// application/zip is supported already on the backend
const zipTypeVariants = ['application/x-compress', 'application/x-compressed', 'application/x-zip', 'application/x-zip-compressed', 'multipart/x-zip'];

const lookupFallbackMimeMap = {
    'application/mspowerpoint': 'ppt',
    ...getZipTypeVariants(),
};

export function getZipTypeVariants() {
    const zipTypeMap = {};
    zipTypeVariants.forEach((mime) => {
        zipTypeMap[mime] = 'zip';
    });

    return zipTypeMap;
}

export function lookupMimeExtension(mediaType: string) {
    return extension(mediaType) || lookupFallbackMimeMap[mediaType];
}
